import React from 'react';
export function Footer() {
  return <footer className="bg-deep px-4 py-6 text-center sm:px-6" data-id="element-64" data-mp="32wd2qgad7ltj">
      <p className="font-heading text-xs font-bold uppercase text-cream/90" data-id="element-65" data-mp="3gfitoga0y7d2">
        © 2026 CAREGIVER READY™ — All Rights Reserved.
      </p>
      <p className="mx-auto mt-2 max-w-2xl text-[0.7rem] leading-snug text-cream/60 sm:text-xs" data-id="element-66" data-mp="32pp5m06cfr4e">
        CAREGIVER READY™ provides professional organization and reference
        resources for caregivers. It does not replace required professional
        training, individualized care plans, medical advice, employer or agency
        policies, emergency procedures or applicable professional instructions.
      </p>
      <p className="mt-2 text-[0.7rem] text-cream/70 sm:text-xs" data-id="element-67" data-mp="3lgonkhff80o6">
        Terms &amp; Conditions • Privacy Policy • Contact
      </p>
      <p className="mt-1 text-[0.7rem] text-cream/70 sm:text-xs" data-id="element-68" data-mp="29yxehh44xsnx">
        Support:{' '}
        <a href="mailto:kitonline27@gmail.com" className="underline" data-id="element-69" data-mp="2eyt6sj3gzvnn">
          kitonline27@gmail.com
        </a>
      </p>
    </footer>;
}